/* eslint-disable react-hooks/exhaustive-deps */
import { Close } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { resetUpdateCampaignReportStates } from "../../redux/MISReportsManagement/misReportsSlice";
import { CloseOutlined } from "@mui/icons-material";


export default function UpdateMISReportsComponent({
    open,
    handleClose,
    updateDates,
    setUpdateDates,
    handleClear,
    handleUpdate,
    error,
    success,
    loading,
}) {
    const [valid, setValid] = useState(true);
    const dispatch = useDispatch();

    const validateDateRange = () => {
        if (updateDates.startDate && updateDates.endDate) {
            const diff = dayjs(updateDates.endDate).diff(dayjs(updateDates.startDate), "day");
            setValid(diff <= 31);
        } else {
            setValid(false);
        }
    };

    useEffect(() => {
        validateDateRange();
        let timer;
        if (success || error) {
            timer = setTimeout(() => {
                dispatch(resetUpdateCampaignReportStates());
                handleClose();
            }, 1500);
        }
        return () => {
            clearTimeout(timer);
        };
    }, [updateDates, error, success]);

    const handleDateChange = (date, name) => {
        setUpdateDates(prev => ({ ...prev, [name]: date }));
    };

    return (
        <Dialog open={open} onClose={handleClose} sx={{ padding: "1rem" }} >


            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant='h5'>Update MIS Reports</Typography>
                <IconButton onClick={() => handleClose()}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <Divider sx={{ width: "100%", color: "black" }} />
            <DialogContent>
                <Typography>Please select the Date range to update reports between (Limit: 7 days).</Typography>
                <Grid
                    item
                    mt={5}
                    gap={5}
                    sx={{
                        display: "flex",
                        // justifyContent: "center",
                        // alignItems: "center",
                        flexDirection: "row",
                    }}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Start Date"
                            name="startDate"
                            value={updateDates.startDate}
                            onChange={date => handleDateChange(date, "startDate")}
                            format="DD/MM/YYYY"
                            maxDate={updateDates.endDate}
                            disableFuture
                            disabled={loading}
                        />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="End Date"
                            name="endDate"
                            value={updateDates.endDate}
                            onChange={date => handleDateChange(date, "endDate")}
                            format="DD/MM/YYYY"
                            minDate={updateDates.startDate}
                            disableFuture
                            disabled={loading}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    {!valid && (
                        <DialogContentText mt={5} sx={{ color: "red" }}>
                            The date range should not exceed 7 days.
                        </DialogContentText>
                    )}
                </Grid>
                <Grid sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    {success && (
                        <DialogContentText mt={5} sx={{ color: "green" }}>
                            Successfully Updated!
                        </DialogContentText>
                    )}
                </Grid>
                <Grid sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    {error && (
                        <DialogContentText mt={5} sx={{ color: "red" }}>
                            {error}
                        </DialogContentText>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions
                style={{
                    padding: "1rem 1.5rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: ".25rem",
                }}
            >
                <Button variant="outlined" color="error" onClick={handleClear}>
                    Clear
                </Button>
                <Button disabled={!valid || loading} sx={{ ml: 1 }} variant="outlined" color="primary" onClick={handleUpdate}>
                    {loading ? <CircularProgress size={25} /> : "Update"}
                </Button>
            </DialogActions>
            {/* </Grid> */}
        </Dialog>
    );
}
